import { render } from "./Details.vue?vue&type=template&id=b9e643ca"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__